import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { VerticalCardLoader } from 'syf-component-library/ui/atoms';
import { useAccountSummary } from '../../../../const/syf-api-queries';
import { ConfigContext } from '../../context';
import { CardHoldersErrors, CardHoldersFooter } from '../../main-container/components';
import { CardholdersScreen } from '../../typings';
import ManageCardHoldersModalContent from '.';
import ManageCardHoldersSamsModalContent from './sams-modal-content';
import ManageCardholderContextProvider from '../../context/manage-card-holder-modal-context';
import triggerManageCardHoldersSamsAnalytics from '../../helpers/trigger-manage-card-holders-sams-analytics';
import triggerManageCardHoldersAnalytics from '../../helpers/trigger-manage-card-holders-analytics';
const ACCOUNT_SERVICES_ANALYTICS = 'account services';
const ManageCardHoldersMainModal = () => {
    const { selectedAccountId, handleClose } = useContext(ConfigContext);
    const { data: accountSummaryData, isError: isSummaryError, isFetching: isSummaryFetching } = useAccountSummary(selectedAccountId);
    const isSamsClient = accountSummaryData?.product?.clientId === 'sams';
    const lookupRequestData = {
        creditType: 'CONSUMER',
        membershipNumber: accountSummaryData?.card?.partnerId || '',
        productType: accountSummaryData?.product?.type || ''
    };
    if (isSummaryFetching) {
        return (_jsx("div", { "data-testid": "skeleton-loader", children: _jsx(VerticalCardLoader, {}) }));
    }
    if (isSummaryError) {
        return (_jsxs(_Fragment, { children: [_jsx(CardHoldersErrors, {}), _jsx(CardHoldersFooter, { isSamsClient: true, handleClose: () => {
                        if (isSamsClient) {
                            triggerManageCardHoldersSamsAnalytics({
                                pageFunction: ACCOUNT_SERVICES_ANALYTICS,
                                pageKind: ACCOUNT_SERVICES_ANALYTICS
                            });
                        }
                        else {
                            triggerManageCardHoldersAnalytics({
                                pageFunction: ACCOUNT_SERVICES_ANALYTICS,
                                pageKind: ACCOUNT_SERVICES_ANALYTICS
                            });
                        }
                        handleClose();
                    }, changeScreen: () => null, currentScreen: CardholdersScreen.INITIAL_SCREEN, usersLimit: "0" })] }));
    }
    return (_jsx(ManageCardholderContextProvider, { children: isSamsClient ? (_jsx(ManageCardHoldersSamsModalContent, { lookupRequestData: lookupRequestData })) : (_jsx(ManageCardHoldersModalContent, {})) }));
};
export default ManageCardHoldersMainModal;
